import { cn } from "@gately/ui";

/**
 * Gately logomark (circle with a gate gap + orange gate-arm). `variant`
 * controls the ring color: "dark" (ink ring, for light backgrounds) or
 * "light" (white ring, for dark backgrounds like the sidebar). `withWordmark`
 * appends the "Gately" wordmark in the matching color.
 */
export function Logo({
  variant = "dark",
  withWordmark = false,
  className,
  ...props
}: React.ComponentProps<"span"> & {
  variant?: "dark" | "light";
  withWordmark?: boolean;
}) {
  const ring = variant === "light" ? "#FFFFFF" : "#0E0E0E";
  return (
    <span className={cn("inline-flex items-center gap-2", className)} {...props}>
      <svg viewBox="0 0 120 120" className="size-7" aria-hidden="true">
        <circle
          cx="60"
          cy="60"
          r="38"
          fill="none"
          stroke={ring}
          strokeWidth="15"
          strokeLinecap="round"
          strokeDasharray="198.97 39.79"
          transform="rotate(30 60 60)"
        />
        <rect x="58" y="52.5" width="37" height="15" rx="7.5" fill="#F75B1E" />
      </svg>
      {withWordmark ? (
        <span
          className={cn(
            "text-base font-semibold tracking-tight",
            variant === "light" ? "text-white" : "text-foreground",
          )}
        >
          Gately
        </span>
      ) : null}
    </span>
  );
}
